import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { LogoutService } from './logout.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private logoutService: LogoutService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {

    const loginDetails = localStorage.getItem('loginDetails');

    if (loginDetails) {
      let currentUser = JSON.parse(<string>loginDetails);

      if (currentUser && currentUser.token) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${currentUser.token.token}`
          }
        });
      }
    }

    return next.handle(request)
      .pipe(
        catchError((err: any) => {
          // Only trigger logout if user is actually logged in
          if (err.status === 401 && loginDetails) {
            this.handleLogout();
          }
          return throwError(err);
        })
      );

   }

   private handleLogout(): void {
     console.log('AuthInterceptor: Subscribing to logout service...');
     this.logoutService.logout().subscribe({
       next: (res) => {
         console.log('AuthInterceptor: Logout success:', res);
       },
       error: (err) => {
         console.error('AuthInterceptor: Logout error:', err);
       },
       complete: () => {
         console.log('AuthInterceptor: Logout completed');
       }
     });
   }
}
